
import React, { useState, useEffect } from 'react';
import { useLocale } from '../../components/special/LanguageProvider';
import { apiGetCall, isResultOk } from '../../components/special/apiCall';
import ListTable from '../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import ReactTooltip  from 'react-tooltip';
import TextAmount from 'components/text/TextAmount';
import TextDateTime from '../../components/text/TextDateTime';
import { useLocation, useHistory } from 'react-router-dom';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const MessageList = ({})  => {

  const params = new URLSearchParams(useLocation().search);  
  const navigator = useHistory();

  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  
  const loadList = async () =>{    

    let jobID = params.get("jobid");    
    if (jobID == null || jobID <= 0){      
      navigator.push("/admin/jobs/commands");
    }    
    const data = await apiGetCall(BASE_URL + '/management/job/messages/'+ jobID);
    if (isResultOk(data, setListError, true)){        
        console.log("messages data", data);
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  return (    
    <div>      
      <a href={"/admin/jobs/commands"}>{t("Aðgerðir")}</a> - <a href={"/admin/jobs/runs?commandid=" + list.commandID}> {list.command} </a>     
      <ListHeader title={t("Aðgerðar keyrslu skilaboð")}/>
      <ReactTooltip/>

      <h3>Almenn skilaboð</h3>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list.messages}
          colsettings = {['100px','180px','']}
          headers = {[
            t("Númer"),
            t("Tími"),            
            t("Skilaboð"),
          ]}
          columns = {[
            (item) => (<>{item.messageID}</>),            
            (item) => (<TextDateTime value={item.messageTime}/>),            
            (item) => (<>{ item.message }</>),
          ]}/>

      <h3>Skilaboð eftir félögum</h3>
      <div>        
        {!listLoading && list && list.companyMessages.map((company, compIndex) =>                     
          <div key={compIndex}>
            {company.companyName} <small>({company.companyID})</small>
            <ListTable           
            list = {company.messages}
            colsettings = {['100px','180px','']}
            headers = {[
              t("Númer"),
              t("Tími"),            
              t("Skilaboð"),
            ]}
            columns = {[
              (item) => (<>{item.messageID}</>),            
              (item) => (<TextDateTime value={item.messageTime}/>),            
              (item) => (<>{ item.message }</>),
            ]}/> 
            </div>       
        )}    
      </div>     
  </div>
  );
};




